exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".warn-msg[data-v-6c1b99de] {\n  margin-right: 10px;\n}\n.warn-msg .el-icon-warning-outline[data-v-6c1b99de] {\n  margin-right: -8px;\n}\n.flex-col[data-v-6c1b99de] {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.flex-col a[data-v-6c1b99de] {\n  padding: 5px 0;\n  cursor: pointer;\n}\n.flex-col a[data-v-6c1b99de]:hover {\n  color: #3e7cee;\n}\n.warn-msg[data-v-6c1b99de] .el-popover {\n  width: 1rem !important;\n}\n", ""]);

// exports
